<template>
  <div>
    <v-card>
      <v-card-title><v-btn color="success" small @click="updateIncomingTerminals"><v-icon>mdi-refresh</v-icon>Refresh</v-btn></v-card-title>      
      <v-card-text>
        <v-data-table :headers="headers" :items="incomingTerminals" dense>
          <template v-slot:item="{ item }">
            <tr @click="openTerminalDetailsDialog(item.terminalId, item.enrolTerminalLocation, item.enrolVenueName, item.enrolTerminalBranch, item.publicId, item.region)" style="cursor:pointer">
              <td style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width:100px;">{{ item.terminalId }}</td>
              <td style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width:200px;">{{ item.publicId }}</td>
              <td>{{ item.enrolTerminalLocation }}</td>
              <td>{{ item.enrolVenueName }}</td>
              <td>{{ item.enrolTerminalBranch }}</td>
              <td>{{ item.enrolTechnicianName }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="terminalDetailsDialog" max-width="700px" persistent>
      <v-card>
        <v-toolbar color="#425058" dark dense>
          <div class="titleBar-content">
            <v-toolbar-title class="raceResults-title">Confirm Terminal Details</v-toolbar-title>
            <v-btn class="cancelButton" icon small @click="closeTerminalDetailsDialog" ><v-icon class="white--text">mdi-close</v-icon></v-btn>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-text-field
            label="Terminal Hash"
            class="mt-2"
            outlined
            dense
            v-model="terminalId"
            disabled
          ></v-text-field>
          <v-text-field
            label="Public ID"
            class="mt-2"
            outlined
            dense
            v-model="publicId"
            disabled
          ></v-text-field>
          <v-text-field
            label="Location"
            class="mt-2"
            outlined
            dense
            counter="45"
            :rules="rules"
            v-model="location"
          ></v-text-field>
          <v-text-field
            label="Branch (if applicable)"
            class="mt-2"
            counter="45"
            :rules="rules"
            outlined
            dense
            v-model="branch"
          ></v-text-field>
          <h3>Venue: {{venue}}</h3>
          <v-select
            v-model="venue"
            :items="venues"
            :rules="[v => !!v || 'Venue is required']"
            label="Select matching venue"
            required
          ></v-select>
          <v-text-field
            label="Username"
            class="mt-2"
            outlined
            dense
            v-model="username"
          ></v-text-field>
          <v-text-field
            v-model="password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            label="Password"
            style="margin-top: 10px;"
            outlined
            dense
            @click:append="show = !show"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="mt2" style="padding-bottom: 26px; padding-top: 26px;">
          <v-btn small color="error" style="position: absolute; right: 120px;" @click="closeTerminalDetailsDialog">Cancel</v-btn>
          <v-btn small color="success" style="position: absolute; right: 25px;" @click="confirmTerminalDetails">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { accessControlMixin } from '../components/mixins/index'
import { VENUENAMETOCODE } from '../common/constants'
export default {
  mixins:[accessControlMixin],
  data () {
    return {
      headers: [
        {
          text: 'Terminal Hash',
          value: ''
        },
        {
          text: 'Public ID',
          value: 'publicId'
        },
        {
          text: 'Location',
          value: ''
        },
        {
          text: 'Venue',
          value: ''
        },
        {
          text: 'Branch',
          value: ''
        },
        {
          text: 'Technician Name',
          value: ''
        }
      ],
      rules: [v => v.length <= 45 || 'Max 45 characters'],
      terminalDetailsDialog: false,
      terminalId: '',
      location: '',
      branch: '',
      venue: '',
      username: '',
      password: '',
      show: false,
      publicId:'',
      region:''
    }
  },
  async created () {
    await this.fetchEnrolledTerminals()
    await this.fetchTerminalVenues()
  },
  computed: {
    ...mapGetters(['getUserPermissions','getUserLoggedIn']),
    ...mapGetters('terminalStore',['getTerminalVenues','getEnrolledTerminals']),
    incomingTerminals () {
       if(this.getUserLoggedIn?.roles.includes('*') 
       || this.userHasResourceAccess(this.RESOURCENAMES.TERMINALS,this.ROLEACTIONCODE.FULL)
       || this.userHasResourceAccess(this.RESOURCENAMES.TERMINALS_INCOMING,this.ROLEACTIONCODE.FULL) || this.userHasResourceAccess(this.RESOURCENAMES.MANAGEMENT)) {
        return this.getEnrolledTerminals
      } else{
        return this.getEnrolledTerminals.filter(t=>this.userHasAccessToVenueTerminal(t))
      }
    },
    venues (){
      if(this.getUserLoggedIn?.roles.includes('*') 
      || this.userHasResourceAccess(this.RESOURCENAMES.TERMINALS,this.ROLEACTIONCODE.FULL)
      || this.userHasResourceAccess(this.RESOURCENAMES.TERMINALS_INCOMING,this.ROLEACTIONCODE.FULL) || this.userHasResourceAccess(this.RESOURCENAMES.MANAGEMENT)) {
        return this.getTerminalVenues.filter(v=>v.region == this.region).map(v=>v.venueCode).sort() 
      } else{
        return this.getTerminalVenues.filter(v=>v.region == this.region && this.userHasAccessToVenue(v.venueCode)).map(v=>v.venueCode).sort() 
      }
    }
  },
  methods: {
    ...mapActions('terminalStore',['fetchTerminalVenues','fetchEnrolledTerminals', 'registerTerminal', 'fetchRegisteredTerminals']),
    openTerminalDetailsDialog (terminalId, terminalLocation, terminalVenue, terminalBranch, publicId, region) {
      this.terminalDetailsDialog = true
      this.terminalId = terminalId
      this.location = terminalLocation
      this.branch = terminalBranch
      this.venue = terminalVenue
      this.publicId = publicId
      this.region = region
    },
    closeTerminalDetailsDialog () {
      this.terminalDetailsDialog = false
      this.terminalId = ''
      this.location = ''
      this.branch = ''
      this.venue = ''
      this.publicId = ''
      this.region = ''
    },
    async confirmTerminalDetails () {
      await this.registerTerminal({ terminalId: this.terminalId, location: this.location, venue: this.venue, username: this.username, password: this.password, branch: this.branch })
      await this.fetchEnrolledTerminals()
      await this.fetchRegisteredTerminals()
      this.terminalDetailsDialog = false
      this.terminalId = ''
      this.location = ''
      this.branch = ''
      this.venue = ''
      this.publicId = ''
      this.region = ''
    },
    async updateIncomingTerminals () {
      await this.fetchEnrolledTerminals()
    },
    userHasAccessToVenue(venueCode){
      return this.getUserPermissions.find(p=>p.uri.split('-').includes(venueCode) && (p.actions.includes(this.ROLEACTIONCODE.READ) || p.actions.includes(this.ROLEACTIONCODE.FULL)))
    },
    userHasAccessToVenueTerminal(terminal){
      let venueCode = VENUENAMETOCODE[terminal.enrolVenueName.toUpperCase()] || terminal.enrolVenueName.toUpperCase()
      return this.userHasAccessToVenue(venueCode)
    }
  }
}
</script>
